export enum Nationality {
  AFGHANISTAN = 'Afghane',
  ALBANIE = 'Albanaise',
  ALGERIE = 'Algérienne',
  ALLEMAGNE = 'Allemande',
  ETATS_UNIS = 'Americaine',
  ANDORRE = 'Andorrane',
  ANGOLA = 'Angolaise',
  ANTIGUA_ET_BARBUDA = 'Antiguaise-et-Barbudienne',
  ARGENTINE = 'Argentine',
  ARMENIE = 'Armenienne',
  AUSTRALIE = 'Australienne',
  AUTRICHE = 'Autrichienne',
  AZERBAIDJAN = 'Azerbaïdjanaise',
  BAHAMAS = 'Bahamienne',
  BAHREIN = 'Bahreinienne',
  BANGLADESH = 'Bangladaise',
  BARBADE = 'Barbadienne',
  BELGIQUE = 'Belge',
  BELIZE = 'Belizienne',
  BENIN = 'Béninoise',
  BHOUTAN = 'Bhoutanaise',
  BIELORUSSIE = 'Biélorusse',
  BIRMANIE = 'Birmane',
  GUINEE_BISSAU = 'Bissau-Guinéenne',
  BOLIVIE = 'Bolivienne',
  BOSNIE_HERZEGOVINE = 'Bosnienne',
  BOTSWANA = 'Botswanaise',
  BRESIL = 'Brésilienne',
  ROYAUME_UNI = 'Britannique',
  BRUNEI = 'Brunéienne',
  BULGARIE = 'Bulgare',
  BURKINA = 'Burkinabée',
  BURUNDI = 'Burundaise',
  CAMBODGE = 'Cambodgienne',
  CAMEROUN = 'Camerounaise',
  CANADA = 'Canadienne',
  CAP_VERT = 'Cap-verdienne',
  CENTRAFRIQUE = 'Centrafricaine',
  CHILI = 'Chilienne',
  CHINE = 'Chinoise',
  CHYPRE = 'Chypriote',
  COLOMBIE = 'Colombienne',
  COMORES = 'Comorienne',
  CONGO_BRAZZAVILLE = 'Congolaise',
  CONGO_KINSHASA = 'Congolaise',
  ILES_COOK = 'Cookienne',
  COSTA_RICA = 'Costaricaine',
  CROATIE = 'Croate',
  CUBA = 'Cubaine',
  DANEMARK = 'Danoise',
  DJIBOUTI = 'Djiboutienne',
  REPUBLIQUE_DOMINICAINE = 'Dominicaine',
  DOMINIQUE = 'Dominiquaise',
  EGYPTE = 'Égyptienne',
  EMIRATS_ARABES_UNIS = 'Émirienne',
  GUINEE_EQUATORIALE = 'Équato-guineenne',
  EQUATEUR = 'Équatorienne',
  ERYTHREE = 'Érythréenne',
  ESPAGNE = 'Espagnole',
  TIMOR_LESTE = 'Est-timoraise',
  ESTONIE = 'Estonienne',
  ETHIOPIE = 'Éthiopienne',
  FIDJI = 'Fidjienne',
  FINLANDE = 'Finlandaise',
  FRANCE = 'Française',
  GABON = 'Gabonaise',
  GAMBIE = 'Gambienne',
  GEORGIE = 'Georgienne',
  GHANA = 'Ghanéenne',
  GRENADE = 'Grenadienne',
  GUATEMALA = 'Guatémaltèque',
  GUINEE = 'Guinéenne',
  GUYANA = 'Guyanienne',
  HAITI = 'Haïtienne',
  GRECE = 'Hellénique',
  HONDURAS = 'Hondurienne',
  HONGRIE = 'Hongroise',
  INDE = 'Indienne',
  INDONESIE = 'Indonésienne',
  IRAQ = 'Irakienne',
  IRAN = 'Iranienne',
  IRLANDE = 'Irlandaise',
  ISLANDE = 'Islandaise',
  ISRAEL = 'Israélienne',
  ITALIE = 'Italienne',
  COTE_D_IVOIRE = 'Ivoirienne',
  JAMAIQUE = 'Jamaïcaine',
  JAPON = 'Japonaise',
  JORDANIE = 'Jordanienne',
  KAZAKHSTAN = 'Kazakhstanaise',
  KENYA = 'Kenyane',
  KIRGHIZISTAN = 'Kirghize',
  KIRIBATI = 'Kiribatienne',
  SAINT_CHRISTOPHE_ET_NIEVES = 'Kittitienneet',
  KOWEIT = 'Koweïtienne',
  LAOS = 'Laotienne',
  LESOTHO = 'Lesothane',
  LETTONIE = 'Lettone',
  LIBAN = 'Libanaise',
  LIBERIA = 'Libérienne',
  LIBYE = 'Libyenne',
  LIECHTENSTEIN = 'Liechtensteinoise',
  LITUANIE = 'Lituanienne',
  LUXEMBOURG = 'Luxembourgeoise',
  MACEDOINE = 'Macédonienne',
  MALAISIE = 'Malaisienne',
  MALAWI = 'Malawienne',
  MALDIVES = 'Maldivienne',
  MADAGASCAR = 'Malgache',
  MALI = 'Maliennes',
  MALTE = 'Maltaise',
  MAROC = 'Marocaine',
  ILES_MARSHALL = 'Marshallaise',
  MAURICE = 'Mauricienne',
  MAURITANIE = 'Mauritanienne',
  MEXIQUE = 'Mexicaine',
  MICRONESIE = 'Micronésienne',
  MOLDOVIE = 'Moldave',
  MONACO = 'Monegasque',
  MONGOLIE = 'Mongole',
  MONTENEGRO = 'Monténégrine',
  MOZAMBIQUE = 'Mozambicaine',
  NAMIBIE = 'Namibienne',
  NAURU = 'Nauruane',
  PAYS_BAS = 'Néerlandaise',
  NOUVELLE_ZELANDE = 'Néo-Zélandaise',
  NEPAL = 'Népalaise',
  NICARAGUA = 'Nicaraguayenne',
  NIGERIA = 'Nigériane',
  NIGER = 'Nigérienne',
  NIUE = 'Niuéenne',
  COREE_DU_NORD = 'Nord-coréenne',
  NORVEGE = 'Norvégienne',
  OMAN = 'Omanaise',
  OUGANDA = 'Ougandaise',
  OUZBEKISTAN = 'Ouzbéke',
  PAKISTAN = 'Pakistanaise',
  PALAOS = 'Palaosienne',
  PALESTINE = 'Palestinienne',
  PANAMA = 'Panaméenne',
  PAPOUASIE_NOUVELLE_GUINEE = 'Papouane-Néo-Guinéenne',
  PARAGUAY = 'Paraguayenne',
  PEROU = 'Péruvienne',
  PHILIPPINES = 'Philippine',
  POLOGNE = 'Polonaise',
  PORTUGAL = 'Portugaise',
  QATAR = 'Qatarienne',
  ROUMANIE = 'Roumaine',
  RUSSIE = 'Russe',
  RWANDA = 'Rwandaise',
  SAINTE_LUCIE = 'Saint-Lucienne',
  SAINT_MARIN = 'Saint-Marinaise',
  SAINT_VINCENT_ET_LES_GRENADINES = 'Saint-Vincentaiseet',
  ILES_SALOMON = 'Salomonaise',
  SALVADOR = 'Salvadorienne',
  SAMOA = 'Samoane',
  SAO_TOME_ET_PRINCIPE = 'Santoméenne',
  ARABIE_SAOUDITE = 'Saoudienne',
  SENEGAL = 'Sénégalaise',
  SERBIE = 'Serbe',
  SEYCHELLES = 'Seychelloise',
  SIERRA_LEONE = 'Sierra-Léonaise',
  SINGAPOUR = 'Singapourienne',
  SLOVAQUIE = 'Slovaque',
  SLOVENIE = 'Slovène',
  SOMALIE = 'Somalienne',
  SOUDAN = 'Soudanaise',
  SRI_LANKA = 'Sri-Lankaise',
  AFRIQUE_DU_SUD = 'Sud-Africaine',
  COREE_DU_SUD = 'Sud-Coréenne',
  SOUDAN_DU_SUD = 'Sud-Soudanaise',
  SUEDE = 'Suédoise',
  SUISSE = 'Suisse',
  SURINAME = 'Surinamaise',
  SWAZILAND = 'Swazie',
  SYRIE = 'Syrienne',
  TADJIKISTAN = 'Tadjike',
  TANZANIE = 'Tanzanienne',
  TCHAD = 'Tchadienne',
  TCHEQUIE = 'Tchèque',
  THAILANDE = 'Thaïlandaise',
  TOGO = 'Togolaise',
  TONGA = 'Tonguienne',
  TRINITE_ET_TOBAGO = 'Trinidadienne',
  TUNISIE = 'Tunisienne',
  TURKMENISTAN = 'Turkmène',
  TURQUIE = 'Turque',
  TUVALU = 'Tuvaluane',
  UKRAINE = 'Ukrainienne',
  URUGUAY = 'Uruguayenne',
  VANUATU = 'Vanuatuane',
  VATICAN = 'Vaticane',
  VENEZUELA = 'Vénézuélienne',
  VIET_NAM = 'Vietnamienne',
  YEMEN = 'Yéménite',
  ZAMBIE = 'Zambienne',
  ZIMBABWE = 'Zimbabwéenne',
}
